import { useCallback } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import * as server from '../server';

export const useFetchBalance = () => {
    const { sessionSubscriptionBalances = '' } = useAppSelector(pick(['sessionSubscriptionBalances']));
    const subscriptionBalanceTypes = sessionSubscriptionBalances
        .split(',')
        .map(type => type.trim());

    return useCallback(
        () => server.getBalance(subscriptionBalanceTypes), [subscriptionBalanceTypes]
    );
};
